import CementationTypesEnum from '../../CementationTypesEnum';

import flatPickr  from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import {
  ValidatedInput,
  ValidationMessage,
  Sidebar,
  FormLabel
} from "@/app/shared/components";
import vSelect from 'vue-select';

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => { }
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    vSelect,
    Sidebar,
    FormLabel,
    flatPickr
  },
  data() {
    return {
      cementation: null,
      cementationTypes: CementationTypesEnum.definition,
      cementedOn: null,
      cementedFrom: null,
      cementedTo: null,
      cementLiters: null,
      maxTo: null,

      configDatePicker: { 
        enableTime: false,
        dateFormat: 'Y-m-d'
      },

      holeIds: null,
      codes : null,
      holes: []
    }

  },
  watch: {
    isSidebarActive(val) {
      if (val) this.clearValues();
      this.editData();
    }
  },
  computed: {
    showCementedOn() {
      return this.cementation !== null && this.cementation !== undefined && this.cementation !== 0;
    },
    cementedOnDateRequired() {
      if (!this.showCementedOn) return "";
      return "required";
    },
    showOptionalFields() {
      return this.cementedOn !== null && this.cementedOn !== undefined && this.cementation === 2;
    }
  },
  methods: {
    async submitData() {
      const result = await this.$refs.observer.validate();
      if (!result || this.holes.length === 0) {
        this.$notifySaveError(this.$t("Drilling.Cementation.SaveError"));
        return;
      }

      this.$vs.loading();
      
      const promises = [];
      this.holes.forEach(async hole => {
        const params = {
          holeId: hole.holeId,
          cementationStatus: this.cementation
        };

        if (this.showCementedOn) {
          params.cementedOn = this.cementedOn;
        }

        if (this.cementation === CementationTypesEnum.Cemented) {
          if (hole.cementedFrom !== null) params.cementedFrom = hole.cementedFrom;
          if (hole.cementedTo !== null) params.cementedTo = hole.cementedTo;
          if (hole.cementLiters !== null) params.cementLiters = hole.cementLiters;
        }

        promises.push(this.$cqrsPost("drilling/cementation/changeStatus", params));
      });

      return Promise.all(promises).then(responses => {
        responses.forEach(response => {
          this.$emit("onUpdated", response.data.model);
        });
      }).catch((error) => {
        this.$vs.notify({ title: "Error", text: error.message, color: "danger" });
      }).finally(() => {
        this.$vs.loading.close();
        this.$notifySaveSuccess();
      })
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    editData() {
      const parsedData = JSON.parse(JSON.stringify(this.data));
      if (parsedData.holes) {
        this.holes = parsedData.holes;
        this.holeIds = this.holes.map(_ => _.id);
        this.codes = this.holes.map(_ => _.code);
      }
      if (this.holes && this.holes.length > 0) {
        this.cementation = this.holes[0].cementationStatus;
        if (this.holes.every(_ => _.cementationStatus === 0)) {
          this.cementation = 0;
        }
        this.cementedOn = this.holes[0].cementedOn;
        if (!this.holes.every(_ => _.cementedOn === this.cementedOn)) {
          this.cementedOn = null;
        }
      }

    },
    clearCementedOn() {
      this.cementedOn = null;
    },
    clearValues() {
      this.cementation = null;
      this.holeIds = [];
      this.codes = [];
      this.cementedOn = null;
      this.cementedFrom = null;
      this.cementedTo = null;
      this.cementLiters = null;
      this.maxTo = null;
      this.holes = [{}];
      this.$refs.observer.reset();
    }
  }
}